module.exports = __webpack_public_path__ + "img/TZS09621.d0b1fc8f.jpeg";